export default __webpack_public_path__ + "static/media/tsi.2db0daf2.png";